import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { TranslocoModule } from "@jsverse/transloco";

import { LorenPeriodSelectorFormComponent } from "./components/loren-period-selector-form/loren-period-selector-form.component";
import { LorenEntityFormModule } from "../loren-entity-form/loren-entity-form.module";
import { LorenPeriodSelectorModule } from "../loren-period-selector/loren-period-selector.module";

@NgModule({
  declarations: [LorenPeriodSelectorFormComponent],
  exports: [LorenPeriodSelectorFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    LorenEntityFormModule,
    LorenPeriodSelectorModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatDialogModule,
    TranslocoModule,
  ],
})
export class LorenPeriodSelectorFormModule {}
